export var fontSize = 16;
export var fonts = [
    '"Akkurat LL"',
    '"Helvetica - Neue"',
    'Helvetica',
    'Arial',
];
export var fontFamily = fonts.join(', ');
export var pxToRem = function (size) { return size / fontSize + "rem"; };
var typography = {
    pxToRem: pxToRem,
    fontSize: fontSize,
    htmlFontSize: fontSize,
    fontFamily: fontFamily,
    h1: {
        fontSize: '2rem',
        fontWeight: 700,
        lineHeight: '3rem',
    },
    h2: {
        fontSize: '1.5rem',
        fontWeight: 700,
        lineHeight: '2.25rem',
    },
    h3: {
        fontSize: '1.25rem',
        fontWeight: 700,
        lineHeight: '2rem',
    },
    h4: {
        fontSize: '1rem',
        fontWeight: 700,
        lineHeight: '1.5rem',
    },
    h5: {
        fontSize: '0.875rem',
        fontWeight: 700,
        lineHeight: '1.25rem',
    },
    subtitle2: {
        fontWeight: 700,
        fontSize: '0.75rem',
        lineHeight: '1rem',
    },
    body1: {
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.5rem',
    },
    body2: {
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
    },
    caption: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: '1rem',
    },
    button: {
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.5rem',
        textTransform: 'capitalize',
    },
};
export default typography;
